import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appSpecialPattern]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: SpecialPatternDirective,
      multi: true
    }
  ],
  standalone: false
})
export class SpecialPatternDirective implements Validator {
  private static defaultPattern = /^[\p{L}\p{N}\s]+$/u;
  @Input('appSpecialPattern') forbiddenPattern: string | RegExp;

  static validator(control: AbstractControl, pattern?: string | RegExp): ValidationErrors | null {
    const regex = pattern instanceof RegExp ? pattern : pattern ? new RegExp(pattern) : SpecialPatternDirective.defaultPattern;

    const value: string = control.value;
    if (value && !regex.test(value)) {
      return { appSpecialPattern: true };
    }
    return null;
  }

  constructor() {}

  validate(control: AbstractControl): ValidationErrors | null {
    return SpecialPatternDirective.validator(control, this.forbiddenPattern);
  }
}
